import { UsersThree } from "@phosphor-icons/react";

import useAllLabels from "features/labels/datahooks/useAllLabels";

import Skeleton from "common/components/ui/Skeleton";
import { Tag } from "common/components/ui/Tag";

import DripFilters from "./DripFilters";

import type { DripTargeting } from "../../../../types";

interface DripTargetingLabelsProps {
  targeting: DripTargeting;
  isLoading?: boolean;
}

export default function DripTargetingLabels({
  targeting,
  isLoading = false,
}: DripTargetingLabelsProps) {
  const { allLabels, isLoadingAllLabels } = useAllLabels("workspace");

  if (isLoading || isLoadingAllLabels) {
    return (
      <div className="flex flex-wrap gap-1.5">
        <Skeleton className="h-7 w-32" />
        <Skeleton className="h-7 w-32" />
      </div>
    );
  }

  const isEmptyTargeting = Object.values(targeting).every((filter) =>
    Array.isArray(filter) ? !filter.length : !filter,
  );

  if (isEmptyTargeting)
    return (
      <Tag
        size="md"
        variant="primary-black"
        leftIcon={<UsersThree weight="fill" />}
      >
        All leads
      </Tag>
    );

  return <DripFilters targeting={targeting} labels={allLabels} />;
}
